import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/login/page";
import AuthCallback from "../pages/auth/callback/page";
import Strategies from "../pages/strategies/page";
import StrategyDetail from "../pages/strategies/detail/page";
import Patterns from "../pages/patterns/page";
import HowItWorks from "../pages/how-it-works/page";
import AuthGuard from "../components/feature/AuthGuard";
import SuperAdminGuard from "../components/feature/SuperAdminGuard";
import Layout from "../components/feature/Layout";

function ProtectedPage({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <Layout>{children}</Layout>
    </AuthGuard>
  );
}

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <ProtectedPage><Home /></ProtectedPage>,
  },
  {
    path: "/strategies",
    element: <ProtectedPage><SuperAdminGuard><Strategies /></SuperAdminGuard></ProtectedPage>,
  },
  {
    path: "/strategies/:id",
    element: <ProtectedPage><SuperAdminGuard><StrategyDetail /></SuperAdminGuard></ProtectedPage>,
  },
  {
    path: "/patterns",
    element: <ProtectedPage><SuperAdminGuard><Patterns /></SuperAdminGuard></ProtectedPage>,
  },
  {
    path: "/how-it-works",
    element: <ProtectedPage><HowItWorks /></ProtectedPage>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;